import React, {ReactNode} from "react"

import authentication from "@irati/auth"
import FormattedMessage from "@irati/utils/lang"
import {useUsersForBusiness} from "@irati/identity/hooks"
import Loading from "@irati/ui/src/Loading"
import {H2} from "@irati/ui/src/Typography"
import Badge from "@irati/ui/src/Badge"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"

interface Props {
  children: ReactNode
}

const BusinessAdminHeader = ({children}: Props) => {
  const usersForBusinessVariables = {
    businessId: authentication.business().uuid,
    enabled: true,
    totalOnly: true
  }

  const {load: loadUsers, data: apolloUsers} = useUsersForBusiness(usersForBusinessVariables, {fetchPolicy: "network-only"})
  const {load: loadUsersNoEsd, data: apolloUsersNoEsd} = useUsersForBusiness(
    {...usersForBusinessVariables, hasEmploymentStartDate: false},
    {fetchPolicy: "network-only"}
  )
  const {load: loadUsersNoDob, data: apolloUsersNoDob} = useUsersForBusiness(
    {...usersForBusinessVariables, hasDateOfBirth: false},
    {fetchPolicy: "network-only"}
  )

  const usersTotal = apolloUsers?.total || 0
  const noStartDatesTotal = apolloUsersNoEsd?.total || 0
  const noDatesOfBirthTotal = apolloUsersNoDob?.total || 0

  const theme = useTheme()

  return (
    <Loading load={[loadUsers, loadUsersNoEsd, loadUsersNoDob]} useLoader={false}>
      <Flex alignItems="baseline" justifyContent="space-between" marginBottom>
        <Flex alignItems="baseline" wrap="wrap">
          <H2 marginRight>
            <FormattedMessage id="admin.containers.manageUsers.nameCountAndButton.title" />
          </H2>
          <Flex wrap="wrap" gap={1}>
            {usersTotal > 0 && (
              <Badge bgColor={theme.colors.primary2} color={theme.colors.greys.white} padding={[0, 1]}>
                <FormattedMessage id="admin.containers.manageUsers.nameCountAndButton.count" values={{total: usersTotal}} />
              </Badge>
            )}
            {noStartDatesTotal > 0 && (
              <Badge bgColor={theme.colors.tertiary.r_400} color={theme.colors.greys.white} padding={[0, 1]}>
                <FormattedMessage id="admin.containers.manageUsers.noEsdCount.count" values={{total: noStartDatesTotal}} />
              </Badge>
            )}
            {noDatesOfBirthTotal > 0 && (
              <Badge bgColor={theme.colors.tertiary.r_400} color={theme.colors.greys.white} padding={[0, 1]}>
                <FormattedMessage id="admin.containers.manageUsers.noDobCount.count" values={{total: noDatesOfBirthTotal}} />
              </Badge>
            )}
          </Flex>
        </Flex>
        {children}
      </Flex>
    </Loading>
  )
}
export default BusinessAdminHeader
